// extracted by mini-css-extract-plugin
export default {"label":"count-chip_label__o7vpZ","root":"count-chip_root__dqrEe"};